
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/banner",
      function () {
        return require("private-next-pages/banner/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/banner"])
      });
    }
  